import { Box } from '@mui/material';
import styles from './SummarySkeleton.module.css';

export function SummarySkeleton() {
  return (
    <Box sx={{ width: '100%' }}>
      <div className={styles.line} style={{ height: 25, marginBottom: 16 }} />
      <div className={styles.line} style={{ height: 70, marginBottom: 16 }} />
      <div className={styles.line} style={{ height: 70 }} />
    </Box>
  );
}
